import { useEffect, useRef } from 'react';
import { useUserState } from '../context/UserContext/UserContext';

const GenesysWrapper = ({ children }) => {
  const userState = useUserState();
  const didSendRef = useRef(false);

  useEffect(() => {
    if (!window.Genesys) {
      console.error('Genesys is not available');
      return;
    }

    const sendAttributes = () => {
      if (!userState?.amisId) {
        console.warn('Skipping Genesys Database.set: missing amisId');
        return;
      }

      const payload = {
        messaging: {
          customAttributes: {
            ID: String(userState.amisId),
            Name: `${userState.firstName ?? ''} ${userState.lastName ?? ''}`.trim(),
            Phone: userState.phoneNumber ?? '',
            sentAt: new Date().toISOString(),
          },
        },
      };

      const traceId = `genesys-dbset-${Date.now()}`;
      console.log(`[${traceId}] Sending Genesys attributes`, payload);

      try {
        window.Genesys(
          'command',
          'Database.set',
          payload,
          (data) => {
            didSendRef.current = true;
            console.log(`[${traceId}] Database.set success`, data);
          },
          (error) => {
            didSendRef.current = false;
            console.error(`[${traceId}] Database.set failed`, error);
          },
        );
      } catch (err) {
        didSendRef.current = false;
        console.error(`[${traceId}] Database.set threw exception`, err);
      }
    };

    const onDatabaseReady = () => {
      console.log('Genesys Database.ready fired');
      sendAttributes();
    };

    const onMessengerOpened = () => {
      console.log('Genesys Messenger.opened fired');
      if (!didSendRef.current) {
        sendAttributes();
      }
    };

    window.Genesys('subscribe', 'Database.ready', onDatabaseReady);
    window.Genesys('subscribe', 'Messenger.opened', onMessengerOpened);

    return () => {
      window.Genesys('unsubscribe', 'Database.ready', onDatabaseReady);
      window.Genesys('unsubscribe', 'Messenger.opened', onMessengerOpened);
    };
  }, [
    userState?.amisId,
    userState?.firstName,
    userState?.lastName,
    userState?.phoneNumber,
  ]);

  return children;
};

export default GenesysWrapper;
